import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { TruLabel } from 'common/trulabel';

const useStyles = makeStyles(() => ({
  headerContainer: {
    height: 25,
  },
  headerTitleContainer: {
    height: 25,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  headerTitle: {
    whiteSpace: 'nowrap',
  },
  headerSubTitleContainer: {
    height: 25,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: -5,
  },
  headerSubtitle: {
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: 14,
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CardTitle = (props: any) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.headerTitleContainer}>
        <TruLabel suffix={props.title} />
      </div>
      <div className={classes.headerSubTitleContainer}>
        <Typography className={classes.headerSubtitle} variant="subtitle2">
          {props.subtitle}
        </Typography>
      </div>
    </div>
  );
};

export default CardTitle;
